<template>
  <transition name="view" appear>
    <div class="analytics">
      <router-view></router-view>
    </div>
  </transition>
</template>

<script>
import { mapMutations } from 'vuex';
import { TEMPLATE_ANALYTICS } from '@/utils/constants';

export default {
  name: 'Analytics',
  methods: {
    ...mapMutations('globalState/app', ['setTemplate']),
  },
  mounted() {
    this.setTemplate(TEMPLATE_ANALYTICS);
  },
};
</script>

<style lang="scss" scoped>
.analytics {
  width: 100%;
  height: 100%;
}
</style>
